import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=72ed4708&scoped=true&"
import script from "./InfoItem.vue?vue&type=script&lang=js&"
export * from "./InfoItem.vue?vue&type=script&lang=js&"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=72ed4708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed4708",
  null
  
)

export default component.exports